import { render, staticRenderFns } from "./BaseTypeAhead.vue?vue&type=template&id=038371d0&scoped=true&lang=html"
import script from "./BaseTypeAhead.vue?vue&type=script&lang=js"
export * from "./BaseTypeAhead.vue?vue&type=script&lang=js"
import style0 from "./BaseTypeAhead.vue?vue&type=style&index=0&id=038371d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038371d0",
  null
  
)

export default component.exports